// extracted by mini-css-extract-plugin
export default {"content":"support_content__fHfm-","form":"support_form__qNbAG","delimiter":"support_delimiter__gDegQ"};